<template>
  <section class="fixed bottom-1/4 right-0 z-[9999]">
    <button
      v-if="!isOpened"
      class="bg-background-positive-primary text-static-white absolute right-[-27px] top-[-50px] -rotate-90 whitespace-nowrap rounded-t-xl p-2 font-bold"
      type="button"
      @click="isOpened = true"
    >
      Debug bar
    </button>
    <div
      v-if="isOpened"
      class="bg-background-neutral-secondary min-w-40 space-y-4 rounded-xl rounded-r-none border-2 p-4 dark:border-transparent"
    >
      <div class="flex items-center justify-between font-semibold">
        <h3 class="text-text-neutral-primary text-lg">Debug bar</h3>
        <FreeCloseButton @click="isOpened = false" />
      </div>

      <div class="space-y-3">
        <BaseOption @click="openAuthBottomSheet"> Dev auth </BaseOption>
        <BaseOption @click="openNetworkBottomSheet"> Network logs </BaseOption>
        <BaseOption @click="openAppVersionCacheBottomSheet">
          App Version & Cache
        </BaseOption>
        <BaseOption @click="openOpenLinkBottomSheet"> Open Link </BaseOption>
        <BaseOption @click="openNavigateBottomSheet"> Navigate </BaseOption>
        <BaseOption @click="openRailwaysBottomSheet"> Railways </BaseOption>
        <BooleanOption
          label="Отображать debug bar"
          :value="debugBar.state.value.isDebugBarVisible"
          @onChange="
            debugBar.updateState({
              isDebugBarVisible: !debugBar.state.value.isDebugBarVisible,
            })
          "
        />
        <LanguageOptions
          @onChange="debugBar.updateState({ language: $event })"
        />
        <ThemeChange />
      </div>
    </div>
    <AuthBottomSheet
      :name="authBottomSheetName"
      :is-dev-auth="debugBar.state.value.isDevAuth"
      @onAuthDataChange="debugBar.updateState({ isDevAuth: $event })"
    />
    <NetworkLogs :name="networkBottomSheetName" />
    <AppVersionCacheInfo :name="appVersionCacheBottomSheetName" />
    <OpenLink :name="openLinkBottomSheetName" />
    <NavigateInfo :name="navigateBottomSheetName" />
    <RailwaysBottomSheet :name="railwaysBottomSheetName" />
  </section>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { controllerModel } from 'shared';
  import { FreeCloseButton } from 'freedom-shared';

  import { debugEntity } from '../entities/debug-entity';
  import { BaseOption } from '../entities/base-option';
  import { BooleanOption } from '../entities/boolean-option';
  import { LanguageOptions } from '../entities/language-options';
  import { AuthBottomSheet } from '../widgets/auth-bottom-sheet';
  import { NetworkLogs } from '../widgets/network-logs';
  import { AppVersionCacheInfo } from '../widgets/app-version-cache-info';
  import { OpenLink } from '../widgets/open-link';
  import { NavigateInfo } from '../widgets/navigate';
  import { ThemeChange } from '../features/theme-change';
  import { RailwaysBottomSheet } from '../widgets/railways';

  const isOpened = ref(false);
  const debugBar = debugEntity.model.useDebugState();
  const bottomSheetController = controllerModel.useBottomSheet();

  const authBottomSheetName = 'auth-bottom-sheet';
  const openAuthBottomSheet = () =>
    bottomSheetController.show(authBottomSheetName);

  const networkBottomSheetName = 'network-bottom-sheet';
  const openNetworkBottomSheet = () =>
    bottomSheetController.show(networkBottomSheetName);

  const appVersionCacheBottomSheetName = 'app-version-cache-bottom-sheet';
  const openAppVersionCacheBottomSheet = () =>
    bottomSheetController.show(appVersionCacheBottomSheetName);

  const openLinkBottomSheetName = 'open-link-bottom-sheet';
  const openOpenLinkBottomSheet = () =>
    bottomSheetController.show(openLinkBottomSheetName);

  const navigateBottomSheetName = 'navigate-bottom-sheet';
  const openNavigateBottomSheet = () =>
    bottomSheetController.show(navigateBottomSheetName);

  const railwaysBottomSheetName = 'railways-bottom-sheet';
  const openRailwaysBottomSheet = () =>
    bottomSheetController.show(railwaysBottomSheetName);
</script>

<script lang="ts">
  export default {
    name: 'FreedomDebugBar',
  };
</script>
